function drawArrow(context, start, end, strokeWidth) {
  const angle = Math.atan2(end.y - start.y, end.x - start.x);
  const headLength = Math.max(14, strokeWidth * 4);
  context.beginPath();
  context.moveTo(start.x, start.y);
  context.lineTo(end.x, end.y);
  context.lineTo(end.x - headLength * Math.cos(angle - Math.PI / 6), end.y - headLength * Math.sin(angle - Math.PI / 6));
  context.moveTo(end.x, end.y);
  context.lineTo(end.x - headLength * Math.cos(angle + Math.PI / 6), end.y - headLength * Math.sin(angle + Math.PI / 6));
  context.stroke();
}

export function drawAnnotationOperations(context, document, targetWidth, targetHeight) {
  if (!document?.operations?.length) return;
  const scaleX = targetWidth / document.width;
  const scaleY = targetHeight / document.height;
  const strokeScale = (scaleX + scaleY) / 2;

  context.save();
  context.lineCap = 'round';
  context.lineJoin = 'round';
  document.operations.forEach((operation) => {
    const mapPoint = (point) => ({ x: point.x * scaleX, y: point.y * scaleY });
    context.strokeStyle = operation.color;
    context.lineWidth = operation.strokeWidth * strokeScale;
    if (operation.type === 'pen') {
      context.beginPath();
      operation.points.map(mapPoint).forEach((point, index) => {
        if (index === 0) context.moveTo(point.x, point.y);
        else context.lineTo(point.x, point.y);
      });
      context.stroke();
      return;
    }
    const start = mapPoint(operation.start);
    const end = mapPoint(operation.end);
    if (operation.type === 'arrow') {
      drawArrow(context, start, end, operation.strokeWidth * strokeScale);
    } else if (operation.type === 'rectangle') {
      context.strokeRect(start.x, start.y, end.x - start.x, end.y - start.y);
    } else if (operation.type === 'circle') {
      const radius = Math.hypot(end.x - start.x, end.y - start.y);
      context.beginPath();
      context.arc(start.x, start.y, radius, 0, Math.PI * 2);
      context.stroke();
    }
  });
  context.restore();
}

export function renderAnnotationCanvas(canvas, image, document) {
  if (!canvas || !image) return;
  canvas.width = image.naturalWidth;
  canvas.height = image.naturalHeight;
  const context = canvas.getContext('2d');
  context.clearRect(0, 0, canvas.width, canvas.height);
  context.drawImage(image, 0, 0, canvas.width, canvas.height);
  drawAnnotationOperations(context, document, canvas.width, canvas.height);
}

export function loadAnnotationImage(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = url;
  });
}

export async function createAnnotatedImageBlob(imageUrl, document) {
  const image = await loadAnnotationImage(imageUrl);
  const canvas = window.document.createElement('canvas');
  renderAnnotationCanvas(canvas, image, document);
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => blob ? resolve(blob) : reject(new Error('PNG konnte nicht erzeugt werden.')), 'image/png');
  });
}